import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'

import flagsImg from 'assets/img/language_sprite.png'
import colors from 'components/utils/colors'

import { AVAILABLE_LOCALES } from 'constants/constants'

const AMERICAN = css`
  background-position: 0;
`

const BRITISH = css`
  background-position: -16px;
`

const GERMAN = css`
  background-position: -32px;
`

const ITALIAN = css`
  background-position: -48px;
`

const FlagTitle = styled.span`
  font-size: 12px;
  color: ${colors.secondary60};
`

const CommonStyledFlag = styled.div`
  margin-right: 8px;
  width: ${props => props.isSmallFlag ? 12 : 16}px;
  height: ${props => props.isSmallFlag ? 12 : 16}px;
  border-radius: 50%;
  background: url(${flagsImg}) no-repeat;

  ${props => props.flagName === 'en' && AMERICAN}
  ${props => props.flagName === 'eu_sky' && BRITISH}
  ${props => props.flagName === 'de' && GERMAN}
  ${props => props.flagName === 'it' && ITALIAN}
`

const IconFlag = ({ flagName, withFlagTitle, isSmallFlag, className }) => {
  const localeInfo = AVAILABLE_LOCALES.find(i => i.value === flagName)
  const flagTitle = localeInfo?.label || ''

  return (
    <>
      <CommonStyledFlag flagName={flagName} isSmallFlag={isSmallFlag} className={className} />
      {withFlagTitle &&
        <FlagTitle>{flagTitle}</FlagTitle>
      }
    </>
  )
}

IconFlag.propTypes = {
  flagName: PropTypes.string,
  withFlagTitle: PropTypes.bool,
  isSmallFlag: PropTypes.bool,
}

export default IconFlag
